// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nyTA","title":"Header_title__3OJfJ","side":"Header_side__3i2zK"};